<template>
    <div>
        <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
            <i class="fa fa-wrench" aria-hidden="true"></i>
                Setup API-Key
            <div class="card-header-actions">
                <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
                <small class="text-muted">docs</small>
                </a>
            </div>
            </div>
            <div>
            <b-row>
                <b-col sm="12">
                    <alert-fail :show="isError"> {{ errorMessage }} </alert-fail>
                    <b-alert variant="success" :show="dismissCountDown" dismissible @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">{{successMessage}}</b-alert>
                    <div class="row text-center">
                        <div class="mx-auto mb-3">
                            <b-button :disabled="isError" @click="$router.push({ name: 'messaging-generate-api-key'})" type="submit" variant="primary">
                                <i class="fa fa-plus-circle"></i>
                                Add API-Key
                            </b-button>
                        </div>
                    </div>
                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :per-page="numberPerPage"
                          class="table-api-key"
                          tbody-class="tbody"
                          :fields="fields"
                          :items="list">
                          <template slot="status" slot-scope="row">
                            <b-form-checkbox v-model="row.item.status" name="check-button" switch @change="changeStatus($event, row.item)"></b-form-checkbox>
                          </template>
                          <template slot="id" slot-scope="row">
                            <b-button class="mr-1" size="sm" variant="primary" @click="goChangeSecret(row.item)">Change Secret</b-button>
                            <b-button size="sm" variant="danger" @click="deleteId = row.item.id" v-b-modal.confirmDelete><i class="fa fa-trash-o"></i> Delete</b-button>
                          </template>
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <app-pagination
                        :page="parseInt(currentPage)"
                        :totalRows="totalRows"
                    ></app-pagination>
                </b-col>
            </b-row>
            </div>
        </b-card>
        <!-- modal alert -->
         <alert-confirm
            :id="'confirmDelete'"
            @confirm="confirmDelete">
            confirm to delete ?
          </alert-confirm>
    </div>
</template>

<script>
import AppPagination from '@/components/Pagination';
import { reformatDate } from '../../assets/utils/formatter';
import AlertFail from '../../components/alert/AlertFail';
import AlertConfirm from '../../components/alert/AlertConfirm';

export default {
  data () {
    return {
      isBusy: false,
      numberPerPage: process.env.VUE_APP_NUMBER_PER_PAGE,
      list: [],
      fields: [
        { key: 'appName' },
        { key: 'apiKey' },
        { key: 'status' },
        { key: 'createdBy' },
        { key: 'createdDate' },
        { key: 'id', label: '' }
      ],
      currentPage: 1,
      totalRows: 10,
      errorMessage: '',
      successMessage: '',
      dismissCountDown: 0,
      isUpdated: false,
      isError: false,
      deleteId: ''
    };
  },
  methods: {
    changeStatus (e, rowItem) {
      const fd = new FormData();
      let keyStatus = e ? 'on' : 'off';
      fd.append('status', keyStatus);
      this.axios({
        method: 'patch',
        url: (`${process.env.VUE_APP_URL_MESSAGING_API}/api-key/${rowItem.id}`),
        data: fd
      }).then(res => {
        const respData = res.data;
        if ('Success' === respData.message) {
          this.successMessage = `${rowItem.appName} API Key status has been turn ${keyStatus}`;
          this.isUpdated = true;
          this.dismissCountDown = 10;
        }
      })
        .catch(error => {
          this.isError = true;
          console.log('Error :', error.response);
          this.errorMessage = error.response.data.data > 0 ? error.response.data.data.map(value => value.msg).join(', ') : 'System Error';
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    async getApiKeys () {
      this.list = [];
      try {
        const apiKeysResponse = await this.axios.get(process.env.VUE_APP_URL_MESSAGING_API + '/api-key');
        console.log(apiKeysResponse);
        const apiKeys = apiKeysResponse.data.data.apiKeys;
        for (const apikey of apiKeys) {
          this.list.push({
            id: apikey.id,
            apiKey: apikey.apiKey,
            status: 'on' === apikey.status,
            appId: apikey.app.id,
            appName: apikey.app.name,
            createdBy: apikey.createdBy,
            createdDate: reformatDate(apikey.createdAt)
          });
        }
      } catch (e) {
        console.log(e);
        this.errorHandler(e);
      }

      this.totalRows = this.list.length;
      this.isBusy = false;
      return this.list;
    },
    goChangeSecret (rowItem) {
      let keyId = rowItem.id;
      sessionStorage.setItem('AppNameSecret', rowItem.appName);
      this.$router.push({ name: 'messaging-change-secret', params: { id: keyId } });
    },
    errorHandler (error) {
      this.errorMessage = error.message;
      if (error.response) {
        this.errorMessage = error.response.data.message;
      }
      this.isError = true;
    },
    setDefault () {
      this.isError = false;
      this.isBusy = false;
      this.list = [];
    },
    confirmDelete () {
      this.axios.delete(process.env.VUE_APP_URL_MESSAGING_API + '/api-key/' + this.deleteId)
        .then(response => {
          this.getApiKeys();
        })
        .catch(error => {
          this.errorHandler(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  components: {
    AppPagination,
    AlertFail,
    AlertConfirm
  },
  mounted () {
    this.getApiKeys();
    document.title = 'Admin Console: Messaging Api Keys';
  }
};
</script>

<style scoped>
    .table-api-key{
        color: #5c6873;
    }
</style>
